const baseFroalaConfig = {
  key: import.meta.env.VITE_FROALA_KEY,
  linkEditButtons: [
    "linkOpen",
    "linkStyle",
    "linkEdit",
    "linkRemove",
  ],
  linkInsertButtons: [
    "linkBack",
    "|",
    "linkList",
  ],
  imageEditButtons: [
    'imageDisplay',
    'imageAlign',
    'imageInfo',
    'imageRemove',
  ],
  events: {},
  useClasses: false,
  htmlRemoveTags: [],
};

const desktopToolbarButtons = {
  'moreText': {
    'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
  },
  'moreParagraph': {
    'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
  },
  'moreRich': {
    'buttons': ['insertLink', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertHR']
  },
  'moreMisc': {
    'buttons': ['undo', 'redo', 'fullscreen', 'print', 'spellChecker', 'selectAll', 'html', 'help', 'trackChanges'],
    'align': 'right',
    'buttonsVisible': 2,
  }
};

const mobileToolbarButtons = {
  'moreText': {
    'buttons': ['bold', 'italic', 'underline', 'textColor', 'clearFormatting'],
    'buttonsVisible': 2,
  },
  'moreParagraph': {
    'buttons': ['alignLeft', 'alignCenter', 'alignRight', 'formatOL', 'formatUL', 'outdent', 'indent'],
    'buttonsVisible': 2,
  },
  'moreRich': {
    'buttons': ['insertLink'],
    'buttonsVisible': 2,
  },
  'moreMisc': {
    'buttons': ['undo', 'redo'],
    'align': 'right',
    'buttonsVisible': 2,
  }
};

// Desktop configuration (default)
const froalaConfig = {
  ...baseFroalaConfig,
  toolbarButtons: desktopToolbarButtons,
  trackChangesEnabled: false,
  emoticonsUseImage: false,
};

// Mobile configuration with reduced toolbar
const mobileConfig = {
  ...baseFroalaConfig,
  toolbarButtons: mobileToolbarButtons,
  trackChangesEnabled: false,
};

export default froalaConfig;
export { mobileConfig };